import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";
import {
  DecoratedMessageWithLinkDisplayType,
  DecoratedMessageWithLinkType,
} from "pages/employer-of-record/components/MessageWithLink/types";

export enum TaxableBenefits {
  COMMUTER_ALLOWANCE = "Commuter Allowance",
  EDUCATION = "Education",
  INTERNET_OR_PHONE_ALLOWANCE = "Internet or phone allowance",
  MEAL_ALLOWANCE = "Meal allowance",
  RECREATION_ALLOWANCE = "Recreation Allowance",
  SACHBEZUG_ALLOWANCE = "Sachbezug Allowance",
  WORK_FROM_HOME_ALLOWANCE = "Work from Home Allowance",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage: {
  [key: string]: DecoratedMessageWithLinkType;
} = {
  [TaxableBenefits.SACHBEZUG_ALLOWANCE]: {
    text: "This is a non-cash benefit for goods and services up to €50 per month.",
    displayType: DecoratedMessageWithLinkDisplayType.INFOALERT,
  },
} as const;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
